import { useMutation } from '../';
import { newEmailTemplate } from '../mutations';

export function useNewEmailTemplate() {
  const { data, isLoading, mutate, refresh } = useMutation();

  const run = (variables, onFinish) => {
    mutate(newEmailTemplate, variables, () => {
      if (typeof onFinish === 'function') {
        onFinish();
      }
    });
  };

  return { data, isLoading, run, refresh };
}
